const Tab = ({ tab, onChange }) => (
  <a href={tab.path} className={tab.current ? 'tab selected' : 'tab'} onClick={() => onChange(tab.key)}>
    {tab.text}
  </a >
)

const Tabs = ({ tabs, onChange = () => {} }) => {
  return (
    <div className="tabs">
      {tabs.map((tab, i) => <Tab key={i} tab={tab} onChange={onChange} />)}
    </div>
  )
}

export default Tabs
